import React, {useState} from 'react'
import {CardHeader, CardTitle} from "./index";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../redux/store";
import {copyToClipboard} from "../../helper";
import {ModalPromoCode} from "../modals/modal.promocode";
import styled from "styled-components";
import {IconCopy, IconEdit, IconLink, IconPlus} from "../icons";
import {InfoContWithTextCopy} from "../modals/modal.topup";
import {ButtonSecondary} from "../button";
import {DetailContainer, DetailLabel, DetailValue} from "../modals/modal.withdraw";
import {AlertInfoText} from "../alert";
import {NavAvatar} from "../navbar";

const MAX_PARTNERS_CNT = 4

export const WidgetReferralsCard = styled.div`
    display: flex;
    padding: 16px;
    gap: 20px;
    flex-direction: column;
    align-items: flex-start;
    //align-self: flex-end; //TODO: check if necessary or/or
    //justify-content: space-between;
    flex-shrink: 0;

    border: 1px solid var(--it-stroke-grey);
    background: var(--it-bg-cards);
    backdrop-filter: blur(50px);
`

const CardDescr = styled.div`
    color: var(--it-text-white);
    /* Body */
    font-family: "Basis Grotesque Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
`

const PromoCont = styled.div`
    position: relative;
    padding-bottom: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  
  &:after {
    position: absolute;
    left: 0;
    bottom: 0;
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: var(--it-text-white);
    opacity: 0.04;
  }
`

const LeftCont = styled.div`

`

const BtnsCont = styled.div`
    display: flex;
    gap: 12px;
`

const PromoValue = styled.div`
    color: var(--it-accent-blue);
    /* H3 */
    font-family: "Druk Wide";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.48px;
    text-transform: uppercase;
`

const DetailsConts = styled.div`
  gap: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-self: stretch;
  /*display: grid;
  grid-template-columns: repeat(2, 1fr);*/
`

const LastPartnersContainer = styled.div`
    //margin: 25px 0;
    width: 100%;
`


const PartnerDetailsCards = styled.div`
    margin-top: 20px;
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2, 1fr);
`

const PartnerDetails = styled.div`
    display: flex;
    //width: 50%;
    gap: 12px;
`

const AvatarCont = styled(NavAvatar)`
    
`

const PartnerCont = styled.div`
    
`

const PartnerName = styled.div`
  color: var(--it-text-white);
  /* Body */
  font-family: "Basis Grotesque Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
  letter-spacing: 0.42px;
`

const PartnerBalance = styled.div`
  margin-top: 8px;
  color: var(--it-text-grey);
  /* Description */
  font-family: "Basis Grotesque Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 12px */
  letter-spacing: 0.36px;
  text-transform: uppercase;
`

function EmptyList({data, total}){
    const {t} = useTranslation();
    return (
      <AlertInfoText>
        {t(`widget.referrals.empty_ref_list`)}
      </AlertInfoText>
    )
}

function LastReferralsList({data, total}){
    const {t} = useTranslation();

    return (
        <>
            <CardTitle style={{marginBottom: '4px'}}>{t(`widget.referrals.last_4_partners`)}</CardTitle>

            {!data || data.length <= 0 ?
                <EmptyList />
                : (
                  <PartnerDetailsCards>
                    {
                      data.slice(0, MAX_PARTNERS_CNT).map((referral, idx) => {
                        return (
                          <PartnerDetails key={referral.id}>
                            <AvatarCont style={{ backgroundImage: `url(${referral.avatar ?? '/images/avatar.jpg'})` }} />
                            <PartnerCont>
                              <PartnerName>{referral.name ?? ''}</PartnerName>
                              <PartnerBalance>${referral.balance ?? 0}</PartnerBalance>
                            </PartnerCont>
                          </PartnerDetails>
                        )
                      })
                    }
                  </PartnerDetailsCards>
                )
            }
        </>
    )
}

export const WidgetReferrals = ({
                                    data,
                                    total,
                                    totalInstalls,
                                    promoCode
}) => {
    const {t} = useTranslation();
    const {user, settings} = useAppSelector()
    const [isPromoCodeModalVisible, setPromoCodeModalVisible] = useState(false);

    let inviteLink = `${document.location.protocol}//${document.location.hostname}${document.location.port && document.location.port !== 80 ? `:${document.location.port}` : ``}/auth/signup?rid=${user.invite_code}`;
    return (
      <>
        <WidgetReferralsCard>
          <CardHeader>
            <CardTitle>{t('widget.referrals.title')}</CardTitle>
          </CardHeader>

          <CardDescr>
            {t(`widget.referrals.description`, {refPercent: settings.referral_program_percent})}
          </CardDescr>

          <PromoCont>
            <LeftCont>
              <CardTitle style={{marginBottom: '4px'}}>{t(`widget.referrals.promo_code`)}</CardTitle>

              {!promoCode ? (
                <ButtonSecondary onClick={() => setPromoCodeModalVisible(true)}>
                  {/*<IconPlus size={20}/>*/}
                  {t(`widget.referrals.create_promo_code`)}
                </ButtonSecondary>
              ) : (
                <PromoValue>{promoCode}</PromoValue>
              )
              }
            </LeftCont>

            <BtnsCont>
              {!!promoCode && (
                <>
                  <ButtonSecondary onClick={() => setPromoCodeModalVisible(true)}>
                    <IconEdit size={20}></IconEdit>
                  </ButtonSecondary>

                  <ButtonSecondary onClick={() => copyToClipboard(promoCode)}>
                    <IconCopy size={20}></IconCopy>
                  </ButtonSecondary>
                </>
              )}
            </BtnsCont>
          </PromoCont>

          <DetailsConts>
            <DetailContainer>
              <DetailLabel>
                {t(`widget.referrals.total_partners`)}
              </DetailLabel>
              <DetailValue>
                {total}
              </DetailValue>
            </DetailContainer>

            <DetailContainer>
              <DetailLabel>
                {t(`widget.referrals.total_installs`)}
              </DetailLabel>
              <DetailValue>
                {totalInstalls}
              </DetailValue>
            </DetailContainer>
          </DetailsConts>

          <LastPartnersContainer>
            <LastReferralsList data={data} total={total}/>
          </LastPartnersContainer>

          <InfoContWithTextCopy
            icon={<IconLink size={20}/>}
            label={t(`widget.referrals.invite_link`)}
            text={inviteLink}
          />

          <ModalPromoCode
            isOpen={isPromoCodeModalVisible}
            onCancel={() => setPromoCodeModalVisible(false)}
          />
        </WidgetReferralsCard>
      </>
    )
}
